var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D13C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0077 14.5098L47.1172 40.6793C47.3476 41.0783 47.4689 41.531 47.4689 41.9917C47.4689 42.4525 47.3476 42.9052 47.1172 43.3042C46.8868 43.7033 46.5555 44.0347 46.1564 44.2651C45.7574 44.4955 45.3047 44.6168 44.8439 44.6168H14.6249C14.1642 44.6168 13.7115 44.4955 13.3125 44.2651C12.9134 44.0347 12.5821 43.7033 12.3517 43.3042C12.1213 42.9052 12 42.4525 12 41.9917C12 41.531 12.1213 41.0783 12.3517 40.6793L27.4612 14.5098C28.4709 12.7598 30.9962 12.7598 32.0077 14.5098ZM29.7344 35.2508C29.2703 35.2508 28.8252 35.4351 28.497 35.7633C28.1688 36.0915 27.9844 36.5366 27.9844 37.0008C27.9844 37.4649 28.1688 37.91 28.497 38.2382C28.8252 38.5664 29.2703 38.7508 29.7344 38.7508C30.1986 38.7508 30.6437 38.5664 30.9719 38.2382C31.3001 37.91 31.4844 37.4649 31.4844 37.0008C31.4844 36.5366 31.3001 36.0915 30.9719 35.7633C30.6437 35.4351 30.1986 35.2508 29.7344 35.2508ZM29.7344 23.0008C29.3058 23.0008 28.8921 23.1582 28.5718 23.443C28.2515 23.7278 28.0468 24.1203 27.9967 24.546L27.9844 24.7508V31.7508C27.9849 32.1968 28.1557 32.6258 28.4619 32.9502C28.7681 33.2745 29.1866 33.4697 29.6319 33.4958C30.0771 33.522 30.5156 33.3771 30.8576 33.0908C31.1997 32.8045 31.4195 32.3984 31.4722 31.9555L31.4844 31.7508V24.7508C31.4844 24.2866 31.3001 23.8415 30.9719 23.5133C30.6437 23.1851 30.1986 23.0008 29.7344 23.0008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attentionIcon.0526123903dd9f1831de12b5907858b9.svg";
export { ForwardRef as ReactComponent };